import { render, staticRenderFns } from "./KiberDashboard.vue?vue&type=template&id=65a1e0b4&scoped=true&"
import script from "./KiberDashboard.vue?vue&type=script&lang=js&"
export * from "./KiberDashboard.vue?vue&type=script&lang=js&"
import style0 from "./KiberDashboard.vue?vue&type=style&index=0&id=65a1e0b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1e0b4",
  null
  
)

export default component.exports